<template>
  <SfSearchInput
    name="overview-search"
    :compact="compact"
    :focused-at="canBeFocused ? focusedAt : 0"
    :placeholder="I18n.t('reconciliation_review.search.placeholder')"
    :model-value="searchTerm"
    :show-result-navigation="false"
    @clear="searchStore.clearSearch"
    @update:model-value="handleUpdate"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import SfSearchInput from '@app/shared/vue/components/sf-search/search-input.vue'

interface Props {
  canBeFocused?: boolean
  compact?: boolean
}

defineProps<Props>()

import { useWorkflowOverviewSearch } from '../store/search'

const emit =
  defineEmits<{
    'searched-for': [value: string | null]
  }>()

const I18n = window.I18n

const searchStore = useWorkflowOverviewSearch()

const { focusedAt, searchTerm } = storeToRefs(searchStore)

function handleUpdate(value: string | null) {
  if (value !== searchTerm.value) {
    if (value) {
      searchStore.searchFor(value)
      emit('searched-for', value)
    } else {
      searchStore.clearSearch()
    }
  }
}
</script>
